/* Asset URLs for Kayla's Garden branding */
export const MUM_HERO_LOGO = "/mums-shed/mums-hero.png";
export const MUM_BANNER = "/mums-shed/mums-banner.png";
export const MUM_BG = "/mums-shed/background.png";

export const MUM_TILES = {
  tubers:   { src: "/mums-shed/tile-tubers.png",   to: "/kaylas-garden/tubers",   label: "Kayla's Dahlia Tubers" },
  blooms:   { src: "/mums-shed/tile-blooms.png",   to: "/kaylas-garden/blooms",   label: "Kayla's Dahlia Blooms" },
  flowers:  { src: "/mums-shed/tile-flowers.png",  to: "/kaylas-garden/flowers",  label: "Kayla's Flowers" },
  seeds:    { src: "/mums-shed/tile-seeds.png",    to: "/kaylas-garden/seeds",    label: "Kayla's Seeds" },
  journal:  { src: "/mums-shed/tile-journal.png",  to: "/kaylas-garden/journal",  label: "Journal" },
  database: { src: "/mums-shed/tile-database.png", to: "/kaylas-garden/database", label: "Database" },
  gallery:  { src: "/mums-shed/tile-gallery.png",  to: "/kaylas-garden/gallery",  label: "Gallery" },
  summary:  { src: "/mums-shed/tile-summary.png",  to: "/kaylas-garden/summary",  label: "Garden Summary" },
  wishlist: { src: "/mums-shed/tile-wishlist.png", to: "/kaylas-garden/wishlist", label: "Wishlist" },
  tasks:    { src: "/mums-shed/tile-tasks.png",    to: "/kaylas-garden/tasks",    label: "Garden Tasks" },
  builder:  { src: "/mums-shed/tile-builder.png",  to: "/kaylas-garden/builder",  label: "Garden Builder" },
};
